import { render, staticRenderFns } from "./SupplierInfo.view.vue?vue&type=template&id=5d20412f&"
import script from "./SupplierInfo.view.vue?vue&type=script&lang=js&"
export * from "./SupplierInfo.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d20412f')) {
      api.createRecord('5d20412f', component.options)
    } else {
      api.reload('5d20412f', component.options)
    }
    module.hot.accept("./SupplierInfo.view.vue?vue&type=template&id=5d20412f&", function () {
      api.rerender('5d20412f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/partials/SupplierInfo.view.vue"
export default component.exports